import React from "react";
import DateFormatting from "../../common_components/DateFormatting";

function SessionTitleRow(props) {
    const daysAgo = Math.floor(DateFormatting.daysAgo(props.mission_user_list.updated_at))
    const dayString = daysAgo < 1 ? 'Applied recently' : `Applied ${daysAgo} days ago`;

    return (
        <div className="session-title-row">
            <div className="session-title-text">
                {props.firstName + "'s Application"}
            </div>
            <div className="session-title-date">
                {dayString}
            </div>
        </div>
    )
}

export default SessionTitleRow;